
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pools",
      function () {
        return require("private-next-pages/pools/index.js");
      }
    ]);
  